module.exports = __webpack_public_path__ + "placeholder.png?b9455444c7ba48692e14e9896f8a26b9";